import axios from 'axios';
import ConsoleLocalStorage from '../storage/storage';
import { DEV_CONSOLE_URL, APP_MANAGEMENT_URL } from "../config";

export default class DevStorageAPI {
    instance = axios.create({
        baseURL: APP_MANAGEMENT_URL,
        headers: {
            Authorization: 'Bearer ' + ConsoleLocalStorage.getAccessToken(),
        },
    });

    generateSASForKYCDoc(data) {
        return this.instance.post('storage/sas', data, {
            headers: {
                'x-organization-id': ConsoleLocalStorage.getUser().organization,
            },
        });
    }

    uploadFile(url, file, onProgress) {
        var pro = new Promise((resolve, reject) => {
            var ins = axios.create({});
            // var formData = new FormData();
            // formData.append('file',file);

            // var promise = new Promise(this.getBuffer(file));

            // promise.then(result=>{
            //     resolve(ins.put(url,result,{headers: {

            //         'x-ms-blob-type':'BlockBlob',
            //         'Content-Type': 'image/png'
            //     },
            //         onUploadProgress:(progressEvent)=>{

            //             onProgress((progressEvent.loaded / progressEvent.total) * 100);
            //         }
            //       }));
            // })

            var fr = new FileReader();
            fr.readAsArrayBuffer(file);
            fr.onload = function () {
                var data = fr.result;
                var array = new Int8Array(data);

                ins.put(url, array, {
                    headers: {
                        'x-ms-blob-type': 'BlockBlob',
                        'Content-Type': file.type,
                    },
                    onUploadProgress: (progressEvent) => {
                        onProgress(
                            Math.floor(
                                (progressEvent.loaded / progressEvent.total) *
                                100
                            )
                        );
                    },
                })
                    .then((response) => resolve(response))
                    .catch((error) => reject(error));
            };
        });

        return pro;
    }

    generateSASForAnyDoc(data) {
        return this.instance.post('storage/generate-sas', data, {
            headers: {
                'x-organization-id': ConsoleLocalStorage.getUser().organization,
            },
        });
    }
}
